import React, {Component} from 'react';
import { Switch, Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom'
import "../CSS/appointment.css"
import AppointmentService from '../utils/AppointmentService.js';

export default class RedeemGiftcard extends Component {
  constructor(props){
  super(props)
    this.state = {
      accountBalance: 0,
      giftcardCode: "",
    }
    this.Appt = new AppointmentService()
  }
  componentDidMount(){
      this.Appt.getUser()
      .then(res =>{
        if(res){
          this.setState({
            accountBalance: res.account_balance
          })
      }
      else{
        this.setState({
          //errorMessage: "Error retrieving account balance, if you think you should have account balance and would like to pay with it, please contact support"
        })
      }
    })
      .catch(err =>{
        this.setState({
          //errorMessage: "Error retrieving account balance, if you think you should have account balance and would like to pay with it, please contact support"
        })
      })
  }
  handleGiftCardChange = event => {
    this.setState({giftcardCode: event.target.value});
  }
  redeemCode(){
    this.Appt.processRedeem(this.state.giftcardCode)
    .then(res =>{
      if(res.errors){
        
      }
      else{
        this.setState({
          accountBalance: res.account_balance
        })
      }
    })
    .catch(err =>{
      this.setState({
        error: "Could not process Giftcard"
      })
    })
  }
  render() {
    return (
      <div>
        <center><h3 className="whiteText">Enter E-Giftcard Number</h3></center>
        <div className="redeemGiftcardDiv">
          <h6>Account Balance: ${this.state.accountBalance/100.0}</h6>
          <p>If you have a valid eGiftcard we will apply it to your available account balance</p>
          <input value={this.state.giftcardCode} onChange={this.handleGiftCardChange}></input>
          <button onClick={() => this.redeemCode()}>Redeem</button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/RedeemGiftcard.js